import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="bg-stage-deep energy-glow text-center text-white" aria-label="Oferta por tiempo limitado" data-id="element-266" data-mp="369xubzheqcj6">
      <div className="energy-bar h-2 w-full" aria-hidden="true" data-id="element-267" data-mp="31ipk51896n4y" />
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-268" data-mp="31h4rxi9evga9">
        <p className="inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[.16em] text-gold" data-id="element-269" data-mp="3g72jm86juo47">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-270" data-mp="3b8iuy00kmy85" /> El precio de lanzamiento termina en
        </p>
        <Countdown light className="mt-5 scale-110" data-id="element-271" data-mp="3p80lokxfglk5" />
        <p className="mt-7 font-bold text-mutedDark" data-id="element-272" data-mp="3l6yoe9n2mjkt">Después sube el precio y no vuelve a bajar.</p>

        <div className="panel-dark mx-auto mt-6 max-w-xl rounded-lg border border-forestSoft p-4 text-sm" data-id="element-273" data-mp="1uu0uhg816876">
          <p className="font-bold" data-id="element-274" data-mp="1qu8rdj1eou97">
            <span className="mr-2 inline-block h-2.5 w-2.5 animate-pulse rounded-full bg-danger" data-id="element-275" data-mp="1qva5jwdpxwv5" />
            Cupos al precio de lanzamiento: quedan pocos
          </p>
          <div className="mt-3 h-3 overflow-hidden rounded-full bg-black/40" data-id="element-276" data-mp="2xtj01vvwtqyz">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '66%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.9,
            ease: [0.23, 1, 0.32, 1]
          }} className="h-full rounded-full bg-gold" data-id="element-277" data-mp="32rkhkcdoti8c" />
          </div>
          <p className="mt-1 text-right text-xs text-mutedDark" data-id="element-278" data-mp="3ghxpieqkwwxo">66% de los cupos tomados</p>
        </div>
      </div>
      <div className="energy-bar h-2 w-full" aria-hidden="true" data-id="element-279" data-mp="3livaez2z452v" />
    </section>;
}